export enum AudioStreamErrorCode {
    Connection = 'connection',
    SendChunks = 'send_chunks'
}

export enum SttClientState {
    Active = 'active',
    Failed = 'failed',
    Closed = 'closed'
}

export enum AudioStreamState {
    Active = 'active',
    Request = 'request',
    Closed = 'closed'
}
